// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__1QF73","Icon":"Languages_Icon__nXPEf","LanguagesSelect":"Languages_LanguagesSelect__Ptocc","minimalist":"Languages_minimalist__1PCOe"};